import type { profile as en } from '@/i18n/locales/en/profile';
import type { Translation } from '@/i18n/types';

export const profile: Translation<typeof en> = {
  title: 'Προφίλ',
  lead: 'Το όνομα, η γλώσσα και οι ρυθμίσεις απορρήτου σας.',
  pendingBadge: '{{count}} εκκρεμές αίτημα συγκατάθεσης',
  nav: {
    label: 'Μενού προφίλ',
    profile: 'Προφίλ',
    consents: 'Συγκαταθέσεις',
    preferences: 'Προτιμήσεις',
    subscription: 'Συνδρομή',
  },
  preferredLanguage: 'Προτιμώμενη γλώσσα',
  preferredLanguageOptional: 'Προτιμώμενη γλώσσα (προαιρετικό)',
  preferredLanguageUnset: 'Δεν έχει οριστεί',
  timezoneUnset: 'Προεπιλογή ανάπτυξης',
  saved: 'Αποθηκεύτηκε.',
  save: 'Αποθήκευση',
  privateFieldsHint:
    'Αυτά τα τέσσερα είναι ιδιωτικά — μόνο εσείς μπορείτε να τα δείτε ή να τα αλλάξετε, όποιος κι αν βλέπει τα υπόλοιπα στοιχεία σας.',
  details: {
    title: 'Στοιχεία',
    rolesTitle: 'Ρόλοι',
  },
  regionAndTimezone: {
    title: 'Περιοχή & ζώνη ώρας',
  },
  fields: {
    name: 'Όνομα',
    email: 'Email',
    nickname: 'Ψευδώνυμο',
    region: 'Περιοχή',
    regionUnset: 'Δεν έχει οριστεί',
    regionHint: 'Η χώρα για την οποία εντοπίζονται τα στατιστικά/οι αναφορές σας.',
    timezone: 'Ζώνη ώρας για στατιστικά',
    timezoneHint: 'Το ημερολόγιο με βάση το οποίο κλείνουν οι ημέρες στατιστικών σας.',
    gender: 'Φύλο',
    birthdate: 'Ημερομηνία γέννησης',
    height: 'Ύψος (cm)',
    weight: 'Βάρος (kg)',
  },
};
